export default {
   
    entrada: {
    }
}